import { combineReducers } from "redux";

//--------------------------------------------
import resellingProductGet from "./resellingProduct/reducer";
import ManufacturedProductGet from "./manufacturedProducts/reducer";
import DelearProductGet from "./delearProduct/reducer";
import CustomerGet from "./customer/reducer"
import DemoProductGet from "./demoProduct/reducer"
import AdminamccustomerGet from "./policyRenewal/reducer"
import adminDashboardGet from "./adminDashboard/reducer";
import adminFinancialGet from "./financial/reducer";
import adminBuyBackGet from "./adminbuyback/reducer";
import adminEarningGet from "./adminearning/reducer";
import serviceGet from "./service/reducer"


// ************ DEALER *************************
import dealerDashboardGet from "./dealerDashboard/reducer";
import  customerProductGet from "./customerProduct/reducer"



//---------------------------------------------
// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";

//E-commerce
import ecommerce from "./e-commerce/reducer";

//Calendar
import calendar from "./calendar/reducer";

//chat
import chat from "./chat/reducer";

//crypto
import crypto from "./crypto/reducer";

//invoices
import invoices from "./invoices/reducer";

//jobs
import JobReducer from "./jobs/reducer";

//projects
import projects from "./projects/reducer";

//tasks
import tasks from "./tasks/reducer";

//contacts
import contacts from "./contacts/reducer";

//mails
import mails from "./mails/reducer";

//Dashboard 
import Dashboard from "./dashboard/reducer";

//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer";

//Dasboard crypto
import DashboardCrypto from "./dashboard-crypto/reducer";

//Dasboard blog
import DashboardBlog from "./dashboard-blog/reducer";

//Dasboard job
import DashboardJob from "./dashboard-jobs/reducer";

const rootReducer = combineReducers({
  resellingProductGet,
  ManufacturedProductGet,
  DelearProductGet,
  CustomerGet,
  DemoProductGet,
  AdminamccustomerGet,
  adminDashboardGet,
  adminFinancialGet,
  adminBuyBackGet,
  adminEarningGet,
  serviceGet,

  dealerDashboardGet,
  customerProductGet,
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  calendar,
  chat,
  mails,
  crypto,
  invoices,
  JobReducer,
  projects,
  tasks,
  contacts,
  Dashboard,
  DashboardSaas,
  DashboardCrypto,
  DashboardBlog,
  DashboardJob
});

export default rootReducer;
